import styled from 'styled-components'

export const WarningText = styled.span({
  marginLeft: '1rem'
})
